import React, { useState, useCallback } from 'react';
import scenes from '../data/scenes';
import LocationScene from './LocationScene';

function pickSentence(scene) {
  // Pick first sentence; future: randomise from scene.sentences array
  return scene.sentences[0];
}

export default function GameFlow() {
  const [sceneIndex, setSceneIndex] = useState(0);
  // Pre-pick one sentence per scene for this playthrough
  const [pickedSentences] = useState(() => scenes.map(pickSentence));

  const handleNext = useCallback(() => {
    setSceneIndex(i => (i + 1) % scenes.length);
  }, []);

  const scene    = scenes[sceneIndex];
  const sentence = pickedSentences[sceneIndex];

  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh' }}>
      {/* Progress dots */}
      <div style={dotsStyle}>
        {scenes.map((_, i) => (
          <div key={i} style={dotStyle(i === sceneIndex)} />
        ))}
      </div>

      <LocationScene
        key={sceneIndex}
        scene={scene}
        sentence={sentence}
        onNext={handleNext}
      />
    </div>
  );
}

const dotsStyle = {
  position: 'absolute',
  top: 20,
  right: 24,
  display: 'flex',
  gap: 10,
  zIndex: 20,
  background: 'rgba(255,255,255,0.7)',
  border: '3px solid #111',
  borderRadius: 50,
  padding: '6px 14px',
  boxShadow: '3px 3px 0 #111',
};

const dotStyle = (active) => ({
  width: 16,
  height: 16,
  borderRadius: '50%',
  background: active ? '#FFD600' : 'white',
  border: '3px solid #111',
  transition: 'background 0.3s',
});
